import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { LoadingSpinnerService } from 'src/app/shared/service/loading-spinner.service';


@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class LoadingSpinnerComponent {
  private readonly loadingSpinnerService = inject(LoadingSpinnerService);

  isLoading: Observable<boolean> = this.loadingSpinnerService.isLoading;
}